export default function CsharpSinglelineComments() {
  return (
    <h2>Csharp SingleLine Comments</h2>
  );
}
